import { Routes } from "@angular/router";
import { authGuard } from "@kno2/core/auth";

export const routes: Routes = [
    {
        path: "callback",
        pathMatch: "full",
        loadComponent: () => import("./callback.component").then((c) => c.CallbackComponent)
    },
    {
        path: "auth-error",
        loadComponent: () => import("./auth-error.component").then((c) => c.AuthErrorComponent)
    },
    {
        path: "account/login/:loginType",
        loadComponent: () => import("./login.component").then((c) => c.LoginComponent)
    },
    {
        path: "account/login",
        pathMatch: "full",
        loadComponent: () => import("./login.component").then((c) => c.LoginComponent)
    },

    {
        path: "account/logout",
        loadComponent: () => import("./logout.component").then((c) => c.LogoutComponent)
    },
    {
        path: "oauth/callback/idproofing",
        canActivate: [authGuard],
        loadComponent: () => import("@kno2/features/onboarding/id-proofing/id-proofing-callback.component").then((c) => c.IdProofingCallbackComponent)
    },
    {
        path: "oauth/callback/:type",
        canActivate: [authGuard],
        loadComponent: () => import("./authorization-code-callback.component").then((c) => c.AuthorizationCodeCallbackComponent)
    }
];
